/**
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Import portions of React that are needed.
import React from 'react'; // Other standard imports.

import { string } from 'prop-types';
export var HTTPErrorSvgOther = function HTTPErrorSvgOther(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1584 916",
    className: className,
    preserveAspectRatio: "xMinYMax meet"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M412 617.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M416 624.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M398.19 625.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M402.19 632.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M384.33 633.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M388.33 640.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M370.48 641.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M374.48 648.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M356.62 649.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M360.62 656.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M342.76 657.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M346.76 664.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M328.91 665.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M332.91 672.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M315.05 673.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M319.05 680.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M301.19 681.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M305.19 688.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M287.34 689.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M291.34 696.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M273.48 697.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M277.48 704.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M259.62 705.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M263.62 712.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M245.77 713.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M249.77 720.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M231.91 721.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M235.91 728.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M218.05 729.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M222.05 736.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M204.2 737.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M208.2 744.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M190.34 745.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M194.34 752.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M176.49 753.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M180.49 760.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M162.63 761.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M166.63 768.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M148.77 769.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M152.77 776.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M138.92 768.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M134.92 775.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M125.06 760.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M121.06 767.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M111.2 752.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M107.2 759.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M97.35 744.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M93.35 751.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M83.49 736.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M79.49 743.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M69.63 728.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M65.63 735.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M55.78 720.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M51.78 727.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M41.92 712.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M37.92 719.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M28.06 704.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M24.06 711.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M14.21 696.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M10.21 703.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient",
    x1: 286.64,
    y1: 562.27,
    x2: 235.8,
    y2: 532.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bebebe",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-2",
    x1: 316.05,
    y1: 537.64,
    x2: 265.64,
    y2: 508.54,
    xlinkHref: "#prefix__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-3",
    x1: 410.05,
    y1: 763.45,
    x2: 1315.84,
    y2: 763.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e0e0e0",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e2e2e2",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e4e4e4",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e7e7e7",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ececec",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f1f1f1",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f7f7f7",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fefefe",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-4",
    x1: 390.79,
    y1: 661.21,
    x2: 437.33,
    y2: 580.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-5",
    x1: 414.06,
    y1: 674.64,
    x2: 460.59,
    y2: 594.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("style", null, '.prefix__cls-1{fill:none}.prefix__cls-69{fill:#697077}.prefix__cls-70{fill:#282828}.prefix__cls-71{fill:#51565c}.prefix__cls-72{fill:#e0dbda}.prefix__cls-73{fill:#003d73}.prefix__cls-75{opacity:.15}')), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: 'isolate'
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient)",
    d: "M280.69 572.58l-44.64-35.42 5.71-14.55 45.59 26.32-6.66 23.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient-2)",
    d: "M273.29 509.65l45.59 23.09-10.47 7.02-45.6-26.32 10.48-3.79z"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    strokeDasharray: "0 16",
    stroke: "url(#prefix__linear-gradient-3)",
    fill: "none",
    d: "M414.05 620.91l336.71 194.4 202.03-116.64L1311.84 906"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(412 609)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSSw7AIAhEh6Ynbc/lWemmYwz+hvatTMQXYDR3Rwa7UR94gfF8jMvHtJLuTuloJWBX56wAWAsi09FUCeu60VRBpI72VUAMl7BtgVT8M7zAfouk+Fe0vxp4U8ssOgpIjX8nmwmItKOdBAgfMnalCMhw2RkBeQAZxjPT3pNTOgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(412 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW22NyQ0AIAzD3I4KczGreRVxRcrHjhRoqrI3+SQBouMBHcQtEqDEASu1XnBfP+/RcQKavRjGL3PgMAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(398 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAe0lEQVQ4T52SQQ7AIAgEF9OXtu/qW+mh2YYqCjJH3UxWQVQVu8gFBQC9Ifb88OM+lEzvM81WEttuKYuaEArbLJAVWYZmFQnwtvsGUJVYBGdiAkm2VmNGOIAsw2pU/qvffqDwTE9CWhSwRLlUs0hCfkvb/11WQtxmuxLyAMz2NejKo2qaAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(398 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVQ4T52SQQ6AMAgEl0b9qT7Kp3rBg8HQlhbKHBsy2cISM2OV4wIDwHOD9Ptmj9uIZARFks0kOt1U5iURRFhGA1GRpkuWkQBfuv8AWYmG9jNwgSBL1RjhHiBKV43Mvtr2A4lvWhKheAMaby6UzJMIVWnb3UUlgplsVSK8+4c10Eqd9NYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(398 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW13KQQoAIRADwTagP9VH7VP3Ek8j0YaBIRR92rbJE8BYmEj/R+NJ9aQWwKtFVPqMqS9ZegPgpxjWGWi8pgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(384 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ6AMAgEl8b6U32UT/WyHkwbWlFo4yRcKJlQskISo6w7CADnAdF9GZEViUYLl/7RwpJYJG/AE+n31808icXjZjMS4L5d3WxWohGSv4gAQPI2kI0Pmm/OonM2/c0+/UAwtBpLUkjegMabC23mSQpNaPvbRSUVkk3ljex70boAY4JtrFm3DDgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(384 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ6AIAwEt8QTvlQf5E89rwcDKVhtIU7SS2kmpVkhiVHWHQSA84DovozIikSjhUv/aGFJLJI34In0++tmnsTicbMZCXDfrm42K9EIyV9EACB5G8jGB803Z9E5m/5mn34gGFqNJSkkb0DjzYU28ySFJrT97aKSCsmm8kb2vWhd8Fltvk/Ar5YAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(384 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW12NQQoAIAzDsh71pfogf+q5nobTQGGU0NGGbZsaAfSJKWgvgg/lUW0B/LYopB32/ZHlY+bMAV2CG+SXNHwdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(370 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiElEQVQ4T62SSw6AIAwFp8SVnlQP5E1Z14XBFC3fOEsKk7Y8UVVG2Q4UIJ6IPZcRWZJYrHB5Fz08iUdoXWiJbL3YWUvi8dnZjATu3T2yWYklwD8iAFn3gWxUiCfSFY0aNmeiqlNjvtMPHTnz8ERgotHTXUmSyHJWErYkieoH9EoS2c7s41ERwAW31Tt9krezkQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(370 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQ4T62S3Q2AIAwGr8QBdE+dxkEZoT4YTNHyG++RwqUtn6gqo2wHChBPxJ7LiCxJLFa4vIsensQjtC60RLZe7Kwl8fjsbEYC9+4e2azEEuAfEYCs+0A2KsQT6YpGDZszUdWpMd/ph46ceXgiMNHo6a4kSWQ5KwlbkkT1A3oliWxn9vGoCOACVpM7htbSFKUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(370 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz05g99RpHNQR4itSPQiU5Ch9SJKoCYCciELsReMjfFQ7AGx7uGZ9c0uTEz2l7QNaBxp9mmUCYwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-8)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(356 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU3Q2AIAwGr4YBdE+dhkEZob5IUgk/rd4jJUchXxFVJcpxoQAlI3ZdIrIqsVjh1hZH9EQty848ktrdUOaRWEpGUrsYlVhenf0RAST4L6nIfgayMaH7ZlFszkRVP12zTT88oe0VZoz2h665OtQVjZWkspxNrwg64zT6XjzcHcY+iLkUDUEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(356 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU3Q2AIAwGr4YVdE0dhTlZor5IUgk/rd4jJUchXxFVJcpxoQAlI3ZdIrIqsVjh1hZH9EQty848ktrdUOaRWEpGUrsYlVhenf0RAST4L6nIfgayMaH7ZlFszkRVP12zTT88oe0VZoz2h665OtQVjZWkspxNrwg64zT6XjzcXJk+gIae2IIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(356 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12KsQ0AIAzDTH+AN+EU7uSJMAW1RMpimz4lSeQHwFiItDib9osAsCjQc/1grkvpukDXF6BcGoU83G4KAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-10)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(342 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU0Q3AIAhEj8YV2jXbUZzTJa4fDQk1UMW+TzQvYA6FJLIcFwgArUJsXTIylViscOsPIzxRXy/eBUsk8QjHzEiAZ1x3zKxIeXW2KlEK8F+iyH4msvFBqxAh+auzpZx5hBuQ6a6XKMPQWiKJMhWNkUQZvtmsCHDWKfpeZrgBHEY+kpxsXeMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-11)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(342 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU0Q3AIAhEj8Yp2i3bORzTOa4fDQk1UMW+TzQvYA6FJLIcFwgArUJsXTIylViscOsPIzxRXy/eBUsk8QjHzEiAZ1x3zKxIeXW2KlEK8F+iyH4msvFBqxAh+auzpZx5hBuQ6a6XKMPQWiKJMhWNkUQZvtmsCHDWKfpeZrgBsd0+qjiv79QAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(342 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12NwQ0AIAjEqmPIljKHYzrH+REj9HU0TWhjSgB70bj0/3gyhjlKstadj6ifTI8omKMkoz6Kxg6AwHBi6AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-12)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(328 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T6WT0Q2AIAxEr4YpdEudgzGZo36YM5VQoPK+SCgvVwqiqohyXHgPlQzhemuX+1hRjcwm60mYLnkFpCepcZNFJMCTrnlnURH5JPsrIQlYlxDZz8lxDigZIqq6lGzp0VqsCDADiKSrJWT4aC2ehLxtjgpH+0DjB9TtzkiI22ZEQm7JxzoJmU9N7wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-13)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(328 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T6WT0Q2AIAxEr4Y9dEqdgS3ZpH6YM5VQoPK+SCgvVwqiqohyXHgPlQzhemuX+1hRjcwm60mYLnkFpCepcZNFJMCTrnlnURH5JPsrIQlYlxDZz8lxDigZIqq6lGzp0VqsCDADiKSrJWT4aC2ehLxtjgpH+0DjB9TtzkiI22ZEQm5ExzoJ1mFIlwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(328 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12MsREAIAjEgovolDqDW7rJ2wgHpoJcwPqUAM7GeLS8hPRhLFTkXzcSXpsUVyFL6W+KdC43XBAJ1fTySwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-14)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(315 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WSwRGAIAwEL459aJVaA13SCX48hokED90Xj7CTXGKlFMywn6gfcoLxvfTL+7QSjykdjQTsao0KgLHAE46mSlj3GE0VeOpoXwXEtkNIW2Bq/RE5wX6LpPWPaK8auLc2E7QXkLr+N1kkIFJGbxLAHaTvShGQbtgzAnIBfJg0OenSruAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-15)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(315 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WSwRGAIAwEL46laJFaAE1SDH48hokED90Xj7CTXGKlFMywn6gfcoLxvfTL+7QSjykdjQTsao0KgLHAE46mSlj3GE0VeOpoXwXEtkNIW2Bq/RE5wX6LpPWPaK8auLc2E7QXkLr+N1kkIFJGbxLAHaTvShGQbtgzAnIBBJk0SQHk8K8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(315 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW22NsQ0AIAzDTG+BI+kBPMkxYSqiQKQsdqRQuySJs8YnBtAcJTgH5RYGECLBSKw3PNfPe3O0AM25GTxv/3OKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-16)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(301 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8ZRdEgdwCUdBj8Mhra0UN5nQ16ucMTMWOW4wADw3CD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9DFwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC8khDU35o/ODwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-17)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(301 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52SQQ6AMAgEl8bP6Bv15B/9Dh4Mhra0UObYkMkWlpgZqxwXGACeG6TfN3vcRiQjKJJsJtHppjIviSDCMhqIijRdsowE+NL9B8hKNLSfgQsEWarGCPcAUbpqZPbVth9IfNOSCMUb0HhzoWSeRKhK2+4uKhHMZKsS4QVTFTUfIOHfXQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(301 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW13KwQkAIRBD0W+60Rr1tD1uO/E0Ev0wMIRHn7Zt8gQwFibS/9F4Uj2pBfBqEZU+Y+pLlt4TshlMVmb5VgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-18)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(287 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAh0lEQVQ4T62SQQ6AMAgEl8bP1DfqyT/6nfVg2tCKQhsn4ULJhJIVkhhl3UEAOA+I7suIrEg0Wrj0jxaWxCJ5A55Iv79u5kksHjebkQD37epmsxKNkPxFBACSt4FsfNB8cxads+lv9ukHgqHVWJJC8gY03lxoM09SaELb3y4qqZBsKm9k34vWBf7+biLcajJbAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-19)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(287 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ7AIAgEF9P/2B/WJ/ZH20OjQUsLmk7CBckEyQpJzLIXEADOAtF9mZFViUYLt/HRwpJYJG/AE+n31808icXjZisS4L5d22xVohGSv4gAQPIxkY0Pum+uonO2/M0x/UAwtBpLUknegMabC23mSSpdaMfbRSUNkl3lgxx70boAi+ZuNMg4FtEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(287 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQIW12NwQkAIAwDr1lIN7QjulF8FasHgRKOlLFs2/QIYCamoZ0EH6qj2wL4bdEoO+z7o8rHrJkDnAYcWhaPDkEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-20)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(273 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAh0lEQVQ4T62SSw6AIAwFp8b76A3liNyoLgymYPnGWVKYtOWJqjLLGVCAGBB7LjOyJLFY4V4WPTyJx9a70BPZerWznsTjs7MVCTy7e2WrEssG/4gA5LgmstEgBmQoGi1szkRVl8Ys0w8DOfPwRGCiMdJdTZLIclYT9iSJ5geMShLZzuzjWRHADchRO7i9KjJ6AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-21)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(273 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62SSw7AIAgFB9Mr9XYuezsPRReNDbX4jbMUnQA+UVVmOS8UIEXEnsuMLEssVniURQ9P4hF6F3oiW6921pN4/Ha2IoFnd69sVWIJsEcEEHaJUkSGotHC5kxUdWnMMv0wkDMPTwQmGiPd1SSZT85qwp4k0/yAUUnmszP7eFYEcAMLijrF4vT/KwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(273 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz85kt/On2zlUfEWqB4GSHKVPSRI1AZALUYg9aHyEj2oHgG0P16xvbmlyoae0fQCQGRq4KaWHHQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-22)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(259 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+NK3c5nt3Mo+qkJNVqh9p5gTjCgqCpRjhMFqAWxcYnImsRihalPzhiJepaVeSStuqnMI7HUguQ+GJVYHpXtiAAy7Esa6S/R8M2i2DkTVf3UZj/9cA/tKPHG7HyozdWlrtFYSRrL3fSKYLBOs+/FwwWRpj1RLfDqigAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-23)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(259 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+NU3cwJuplr0U9NqNEKtfcEc4IBRVWJcpwoQC2IjUtE1iQWK0x9csZI1LOszCNp1U1lHomlFiT3wajE8qhsRwSQYV/SSH+Jhm8Wxc6ZqOqnNvvph3toR4k3ZudDba4udY3GStJY7qZXBIN1mn0vHi7QeT1JFgA9ngAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(259 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12KsQ0AIAzDTL+Cz3gAPuOtMAW1RMpim74kSeQHwNiItDiT9osAsCjQc/1grkvpukDXF9ZuGsBmSXR4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-24)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(245 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62U0Q3AIAhED+NU3cwJuplrXT8aEmogivZ9onkBcygkkeW6QQDoDWLrkpGpxGKFZTyM8ERjvXoXLJHEIxwzIwHecd0xsyLl09muRKnAuUQpf4l6gwjJo862cuYRbkCmu1GiTENriSTKUjRmEmX6ZqsiwFmn6HtZ4QEQNT5H6wcOUAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-25)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(245 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62U0Q3AIAhED+Ne3cohupWTXT8aEmogivZ9onkBcygkkeW6QQDoDWLrkpGpxGKFZTyM8ERjvXoXLJHEIxwzIwHecd0xsyLl09muRKnAuUQpf4l6gwjJo862cuYRbkCmu1GiTENriSTKUjRmEmX6ZqsiwFmn6HtZ4QGlzD5feNEAjwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(245 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12NwQ0AIAjEKoPpVu4gWznZ+RED9nU0TWh9SQB70rhYPp6MMRwV+ddGIuonyyM+hqMioz520A5FI5WFaAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-26)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(231 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T62T0Q3AIAhEj8a9upVDdCsnox/NGWpEpfZ9mYgvh6KoKqKcF+qhkiFcH/1yHytqkdVkIwnTJa+AjCQtbrKIBHjSde8sKiKvZF8lJAH7EnL8JSoZIqq6lWxraC1WBJgHiKRrJWQ6tBZPQmqbs8LZPtD5AW27KxLithmRkBuUYzkNzMPF6gAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-27)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(231 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T62T0Q3AIAhEj8bRupFzdCN3ox/NGWpEpfZ9mYgvh6KoKqKcF+qhkiFcH/1yHytqkdVkIwnTJa+AjCQtbrKIBHjSde8sKiKvZF8lJAH7EnL8JSoZIqq6lWxraC1WBJgHiKRrJWQ6tBZPQmqbs8LZPtD5AW27KxLithmRkBsBujkNpqthLQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(231 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12MsREAIAjEgqvpRq6hG7nb2wgHpoJcwPqSAM7EeLS8hPRhbFTkXzcSXpsUVyFL6W+KdC4wyhAJfDhffAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-28)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(218 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSwRHAIAgEj4ylpSPrSEf2Zj45x0FRiPvygTvAIbVWRLgftA8lQ/i+5uVzeolGPB2tBOwqWQXAWqAxR/NKWDeM5hVo2mh/BSSdCkgofouSIcciV/wr+qsGvtQie9IC0uLfySwBce1oJwHUQequPAIyXXZEQF7XoTOzyj6GnwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-29)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(218 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSwRHAIAgEj4zNpRprSTWWZz45x0FRiPvygTvAIbVWRLgftA8lQ/i+5uVzeolGPB2tBOwqWQXAWqAxR/NKWDeM5hVo2mh/BSSdCkgofouSIcciV/wr+qsGvtQie9IC0uLfySwBce1oJwHUQequPAIyXXZEQF5wnzPFUwUfFgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(218 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW22NyQ0AIAzDTKej07AKTMN44VVUjkj52JFC7ZIkco1PDMAHOuBslFsYQIgDRmK9YV4/7z7QAgDEGbL3Q18bAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-30)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(204 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8bhdBpX0WkcDz8Mhra0UN5nQ16ucMTMWOW4wQDwnCD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9ClwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC98AzSGrOWZawAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-31)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(204 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8b5dBG30UWcED8Mhra0UN5nQ16ucMTMWOW4wQDwnCD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9ClwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC+wZTRrp0g7RQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(204 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQIW13K0QkAIRAD0TEFaiN24zVyFcavlejAwhIefdm2yRPA+DCR/knjSfWkFsCrRVT6jKkvWXoDR4wZxOG4ZqgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-32)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(190 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T62S0Q2AMAgFH43z6SJuo4s44fPD1FDEQJtewg+QCxCEJHrZThAArh2i89IjqxKNFi626OFJPErUEIl0/XeySOLxudmIBHhu9042KtEIySkiACizRM2ao+g/G17Tfj+QfFqNJ6mUqEET9aUmiySV5mnt7bKSF5JNrAdpc9m4AU6sbZ5q9kruAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-33)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(190 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T62S0Q2AMAgFH40b6hIupEu44/PD1FDEQJtewg+QCxCEJHrZThAArh2i89IjqxKNFi626OFJPErUEIl0/XeySOLxudmIBHhu9042KtEIySkiACizRM2ao+g/G17Tfj+QfFqNJ6mUqEET9aUmiySV5mnt7bKSF5JNrAdpc9m4Acveba417E+CAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(190 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12NwQkAIAwDr1lRl3AhXcId46tYPQiUcKS0adumRgB9YQrag+BDeVRbAL8tCmmHfX9k+Zg5cwDaiBzQhMcu8AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-34)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(176 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62S3Q3AIAgGD9MRu4QTdQl3pA+NDbX4G+9R9AL4iaoyy3mhACki9lxmZFliscKjLHp4Eo/Qu9AT2Xq1s57E47ezFQk8u3tlqxJLgD0igLBLlCIyFI0WNmeiqktjlumHgZx5eCIw0RjpribJfHJWE/YkmeYHjEoyn53Zx7MigBt9SDr3geCsOQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-35)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(176 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62S3Q3AIAgGD9Mlu4BDdQHHpA+NDbX4G+9R9AL4iaoyy3mhACki9lxmZFliscKjLHp4Eo/Qu9AT2Xq1s57E47ezFQk8u3tlqxJLgD0igLBLlCIyFI0WNmeiqktjlumHgZx5eCIw0RjpribJfHJWE/YkmeYHjEoyn53Zx7MigBsKZDr/bVjn/wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(176 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz05pF3AnXcAx4ytSPQiU5Ch9SpKoCYBciELsQeMjfFQ7AGx7uGZ9c0uTCz2l7QPFQRryyo9D+AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(162 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+OSXcChuoBj0k9NqNEKtfcEc4IBRVWJcpwoQC2IjUtE1iQWK0x9csZI1LOszCNp1U1lHomlFiT3wajE8qhsRwSQYV/SSH+Jhm8Wxc6ZqOqnNvvph3toR4k3ZudDba4udY3GStJY7qZXBIN1mn0vHi5ZPj0XhHWjCwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-37)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(162 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVQ4T62UMQ7AIAgAD+M7O/iwDn6ULjWhRivU3gjmBAOKqhLlOFGAWhAbl4isSSxWmPrkjJGoZ1mZR9Kqm8o8EkstSO6DUYnlUdmOCCDDvqSR/hIN3yyKnTNR1U9t9tMP99COEm/MzofaXF3qGo2VpLHcTa8IBus0+148XJ/sPQ5VDtx8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(162 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW12KsQ0AIAzDTP+Egb9g4NEwBbVEymKbviRJ5AfA2Ii0OJP2iwCwKNBz/WCuS+m6QNcXDI8a+73Xk4YAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-38)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(148 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVQ4T62UQQ7AIAgEF+M7e/BhPfjR7aEhoQaiaOeIZgJmUUgiy3WDANAbxNYlI1OJxQrLeBjhicZ69S5YIolHOGZGArzjumNmRcqns12JUoFziVL+EvUGEZJHnW3lzCPcgEx3o0SZhtYSSZSlaMwkyvTNVkWAs07R97LCA1+oPvjGQ0E8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-39)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(148 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62UwQ3AIAhFP62LdDIPLtJFPHS2DkIPDQk1EEX7jmhewHwkZkaUcoEBoGaQrlNEJhKNFm7toYclauvJuqDxJBbumBEJ8I5rjhkVCZ/OZiVCAtYlwn4f5y+imkHEzEudTeXMwt2ASHetROiGVuNJhKFo9CRC981GRYCxTt73MsIDKsU/kSq40GAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(148 769)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12NwQkAIAzEYhcVdC7BTnp+rNjmdQ2BtrElgNVpXOw/nowxHSVZa+Mj6ifTIwrTUZJRH2LaDgo5RZMHAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-40)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(134 769)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQ4T62TwQ2AIAxFf9VFnIyDi7iIB2dzkHow31RChYrvREJ5+YUiqoooy4770JYgXA/lch8rypHWZG8Sppu8AvImyXGTRSTAla54Z1EReST7KiET0C8h4zGvv4i2BBFV7UrWNbQWKwLMA0TS5RJSHVqLJyF3m7XC2j5Q+AF5uy0S4rYZkZAT7/o5jjH/r8IAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-41)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(134 768)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN1enBlSkAX3mvtxkdojl3i/Wi4S5OyK1wwGgFRgOeVYLtcNHsIpFs+ywYvqFqRZZ6LLMFdml5u6yFcOWx2YRbtJzaxUZGb/KZOTRUDD+AcBdaCuwaQNagSlDyqTdVAPHvu1onFhO3yyD3zNetDVjMtMXLMJEDa+ZJIwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(134 768)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW23KwQ0AIAzDQLdzsgATsUD3DK8givDTupDE3SyUfGpzFmrTYw2iyTWII63ckVYA+SqADRqWECUVwCw/AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-42)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdQxGaCdiAHKnunLEkqBmHtWwb3E5u4gT4cDQKswHFJmH58OZ6iK0Wj3UDGcGkUUw8LB3RDZzdn9uhQSietKq82I6167YQWGFaURhQJo9WaYh1urDUZ+QeQksFXYMohkgTxLWr96v9RoJNqNP0mNRlqFrQw/do0+Q0Jl4UYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-43)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdQlGaIdhiHKmOnLEkqBmHtWwb3E5u4gT4cDQKswHFJmH58OZ6iK0Wj3UDGcGkUUw8LB3RDZzdn9uhQSietKq82I6167YQWGFaURhQJo9WaYh1urDUZ+QeQksFXYMohkgTxLWr96v9RoJNqNP0mNRlqFrQw/TX0+a4AUFc4AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPklEQVQIW2XKQQ0AIAzF0A7EoAkTaEADJnCHhc+JZRk9Ns8k8RobARRSq2M+n/rk6pjPqADqaVNRuYzDZ+4Cf98PjumwV5IAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-44)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhED7d0iDqMQ9Qxr182xBQB+/6IEd6BkMSkDbxFrxAkKdaDbhxFptnuc9TSNNO0AUZMhWQ6kmUaMluxhst1M2W1oi2PzDR6n0c7syhA/PQ7eoUUXfxtKjT2n4k+JcwDnJi61/Qa6ncz5hdr9HWQa6bxoj86tDzJ0jTAugAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-45)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhED3d0kTqHi9Qhr182xBQB+/6IEd6BkMSkDbxFrxAkKdaDbhxFptnuc9TSNNO0AUZMhWQ6kmUaMluxhst1M2W1oi2PzDR6n0c7syhA/PQ7eoUUXfxtKjT2n4k+JcwDnJi61/Qa6ncz5hdr9HWQa6bxoj+lczyufQ+ragAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW2XKQRHAIAwAwQ0eUVIdKKnI8EqG0nvebGSm6nklDFdrip6lfnJN0fNUH1kKxq1ango2JaQPDXOwQYsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-46)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd69HGrnUQSOhyL0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6AQ+KRXFet+DaAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-47)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd69EmrmUQDOhxb0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6ActmRZFgXwSMAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW13KQREAMAjEwIBE1FQCamrx+oKh5JlZk8TsXOR7APgeGdgnM7CWpaqWpQB8q5ZTATwp+xEyj/4P5AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-48)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T52UwRHAIAgED0u0mpRgNbZ4eZm5OBIg+9ZjFdRIQrkmCACjw1DENGwFKZXQFi04FfB4zDKbIksjmQpSvNDwmCeuCZ4EWtVK2ff+MlPU8tedeYRzVuF1zKj1X4wOs/05LSqWS8JtwOiwqqlrtuOZasH0aGQs02aK903dUz5Hkc4uNVgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-49)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T52UwRHAIAgEDxu0orysyAovLzMXRwJk33qsghpJKNcEAWB0GIqYhq0gpRLaogWnAh6PWWZTZGkkU0GKFxoe88Q1wZNAq1op+95fZopa/rozj3DOKryOGbX+i9Fhtj+nRcVySbgNGB1WNXXNdjxTLZgejYxl2kzxvqkb9MpHsVvTab0AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW13LsRHAMAgEwUUNqiJHqsgV4ggN+MOdv8hMfc8r1x9gIJwtLtbrPgvOFiMvgNWzkfcXfPLBEToy4kOZAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-50)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3EMAgEhzToivJyRamQezlaOURAbr62BxZhc3eU88IB5sBoYipbIqUjPbIL54VHRSJuWfYgO4dCZ0rWpbl7qWrEPs/jqwie0VsxIzT6XzF30j3rYPsPgG/SObBwZp2tV8LOlEqXq3gqW7xJNUV5NebAsvhl2UKFu/wHWslIPL6w6fcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-51)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3EMAgEh9TnmvxITemPezlaOURAbr62BxZhc3eU88IB5sBoYipbIqUjPbIL54VHRSJuWfYgO4dCZ0rWpbl7qWrEPs/jqwie0VsxIzT6XzF30j3rYPsPgG/SObBwZp2tV8LOlEqXq3gqW7xJNUV5NebAsvhl2UKFu/wHewtIdDE6A9IAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW2XKwQ2AMAwAMaesxBidqULMxH7hRRTgntZFZuqdlxxfgBfCmqLwuX7nmqKwX7CN/ch+1dkBbqbAEMOJ8S79AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-52)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T6WTwQ3AIAwDnc7HTDyYif3cF1VkRYTQ+wLOEYKRhGdMEAB6g6GI+bAV5KmEPtmGMcGoSMQXlh3I1oEDM09maSSPqkZoP0tmipo+t1aelfHrmko6ZxVMfwBwF9obLHyA3mCVyV9sX/M0cO1LR6NiGfZsh/bTF0rNFH9YjV8wvUTZLi9QzAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-53)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3AIAwDnU7HSIzASGznvqgiKyKE3hdwjhCMJDxjggDQGwxFzIetIE8l9Mk2jAlGRSK+sOxAtg4cmHkySyN5VDVC+1kyU9T0ubXyrIxf11TSOatg+gOAu9DeYOED9AarTP5i+5qngWtfOhoVy7BnO7SfvlBqpvjDavwCbm5FAWM+xNwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW2XKOREAIBDAwD3UIQkJSMLdUcHwpMxsZKazPmR5B1wTWhV7LvXJVsWep7rkUlBeBROKcBCL4aY5zgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-54)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN1edkpSgJN3tfbnJ7BDh3i/Wi4SRhKd1EABqgeGQZ7XQOjiCs5g3iw5nTL+wrEUUuixzRXSpkUxbKWp5bObRJj23Vp6R8atMJT0aGUx/AHAXWgts2oBaYJkhVcJuZgPHvu1onFhO3yxC39NftDVTItMXdwJEQOvj2eMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-55)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN9ebitShIsXtfbnJ7BDh3i/Wi4SRhKd1EABqgeGQZ7XQOjiCs5g3iw5nTL+wrEUUuixzRXSpkUxbKWp5bObRJj23Vp6R8atMJT0aGUx/AHAXWgts2oBaYJkhVcJuZgPHvu1onFhO3yxC39NftDVTItMXI05ESLhBIZ8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW23KwQ0AIAzDQLe7MRFzMFGHC68givDTupDE3SqUfGpzFWrTYw6iyTmII63ckVYA+SqADVMaEJscxlVcAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-56)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdTVmIg1ykJluPRlCaVA3HtWwb3E5u4gfcABoFUYflJWH/uAM1TFaHR6qBgujSKKYeHgaYic5ux+XAqJxHWl1VbEda/TsALDitKIQgG0ejPMw63VBiOfIPInsFXYNohkgTxLWr96v9RoJtrNP0mNZlqF7Qxfp54/ak8H7RcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-57)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdTJGIhdyj5ltfRlCaVA3HtWwb3E5u4gfcABoFUYflJWH/uAM1TFaHR6qBgujSKKYeHgaYic5ux+XAqJxHWl1VbEda/TsALDitKIQgG0ejPMw63VBiOfIPInsFXYNohkgTxLWr96v9RoJtrNP0mNZlqF7Qxffo4/kulAuGUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW2XKQQ0AMAjF0II0BCFmgmbt7wQhrMeXmiSqcxGAs8rAGuv6zgyscV4AXlBXnxMadw94LA8NAkRlXwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-58)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhEwdEcyF3qPnW165cNMT0B+/6IEd6BApBJH/IWrYpKksIebOMoOs12n6OW1MzShyBiqgDSkZhpyGyFDdfrRspqxVoemVnsPo92xigi8dPvaFW02OJvUwXZfyb6lKAHODF1r+k1tO805hdr9HWQa2bxoj/2kDwYiCNvlAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-59)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhEwcWcx4XqOnWy65cNMT0B+/6IEd6BApBJH/IWrYpKksIebOMoOs12n6OW1MzShyBiqgDSkZhpyGyFDdfrRspqxVoemVnsPo92xigi8dPvaFW02OJvUwXZfyb6lKAHODF1r+k1tO805hdr9HWQa2bxoj9VgDwAcXeIpAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW2XKQRHAIAwAwQ3G0IOi6qmy8EqG0nvebGSm6nklDFdrip6lfnJN0fNUH1kKxq1ango2PEwPDeYK8vMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-60)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(-4 688)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd68x6qGhSzuhsr0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6AWHPRlkBO2yyAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient-4)",
    d: "M507.13 620.91l-93.07 53.72L321 620.91l93.06-53.73 93.07 53.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient-5)",
    d: "M414.06 567.18l93.07 53.73-93.07 53.72V567.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-69",
    d: "M294.65 569.94v-1.85a3.83 3.83 0 01-2.26 3.15 12.1 12.1 0 01-10.93 0 3.81 3.81 0 01-2.26-3.18V570a3.87 3.87 0 002.26 3.14 12.1 12.1 0 0010.93 0 3.83 3.83 0 002.26-3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M293 545.9a3 3 0 00-1.78-2.49 9.51 9.51 0 00-8.63 0 3 3 0 00-1.78 2.49l-1.63 22.16a3.78 3.78 0 002.25 3.18 12.1 12.1 0 0010.93 0 3.83 3.83 0 002.26-3.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-71",
    d: "M290.69 538.19c-2.54-1.52-8.52-1.33-9.09 2.17v6.15c.57 3.5 6.55 3.68 9.09 2.17a2.65 2.65 0 001.56-2.17v-6.15a2.64 2.64 0 00-1.56-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M291.32 555.44l.78-7.22a2.65 2.65 0 00-1.77-2.78l-1.9-.65a4.63 4.63 0 00-3 0l-1.93.66a2.65 2.65 0 00-1.76 2.8l.8 7.2M338 542.36l-13.89-11.7-7.4-4.11a9.76 9.76 0 00-8.49.12 3.62 3.62 0 00-1.81 3.13v5.83a3.06 3.06 0 001.81 2.52l9.17 5.87 8 5.13a5.37 5.37 0 00.53.34c3.56 2.18 12.45 1.89 13.14-3.14v-1.77a2.81 2.81 0 00-1.06-2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-71",
    d: "M316.57 521.57c-2.54-1.52-8.52-1.33-9.09 2.17v6.15c.57 3.5 6.55 3.68 9.09 2.17a2.65 2.65 0 001.56-2.17v-6.15a2.64 2.64 0 00-1.56-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M315.17 534.21l-1.5-1.36a1.23 1.23 0 01.06-1.88l3.79-3.05c.41-.33-.44.29 0 0 1-.9 3-1.81 4.26-.15l2.38 2.9 14 11.75c1.19.89 1 2.63 1 3.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-69",
    d: "M306.45 537.14a3 3 0 001.81 2.53c4.56 2.91 13.18 8.45 17.72 11.34a12 12 0 0010.88 0 3.82 3.82 0 002.26-3.14v-1.66a3.83 3.83 0 01-2.26 3.14 12 12 0 01-10.88 0c-4.54-2.89-13.16-8.43-17.72-11.34a3 3 0 01-1.81-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M278.61 538.26c0 2.1 2.13 3.47 3.89 4.1a14.48 14.48 0 005.54.69c2.93-.19 6.86-1.37 7.29-4.79l2.23-46.49c1-11 3-22 4-33l.56-8.1 2.62-38.14.36-5.17c.23-2.79-1.39-5.32-4.87-7.38-4.17-2.4-10-3.27-15.37-2.61a22 22 0 00-8.35 2.65c-2.72 1.6-5.34 4.35-4.75 7.76l1.1 13.89 2.8 35.35c0 .58.09 1.17.13 1.75 1 11 1.32 22 2.44 33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M304.49 522.74c0 1.81 1.64 3.1 3.18 3.81a13.56 13.56 0 008.11.74c2.78-.56 5.12-2 5.44-4.55 1-19 2.95-38 4-57l1.12-13.13 1.06-12.28.14-5.4 1.11-42.17c.23-2.79-1.39-5.32-4.87-7.37a24.45 24.45 0 00-12.57-2.82c-4.29.11-8.81 1.08-12.34 3.63-2.8 2-4 4.54-3.56 7l6 48 1 7.65 1.08 8.7 1.46 11.7c.15 17.84-.58 35.67-.36 53.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M335 395.49s.52 13.47-2.38 14.47a3 3 0 01-3.88-1.93l.28-11.22a6 6 0 006.98-2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-73",
    d: "M338 331.19c.76-17.55-16.49-30.44-31.67-21.33-4.14 1.78-16.7 5.93-17.56 6.34-20.19 15.54-29.1 20.77-30.57 44.72 0 0-2.51 33.64 8.55 47.12.75.91 2.45 1.43 4.38 1.59 1.16 3.78 3.66 11.62 7.49 14.08a26.06 26.06 0 008.54 3.41 47 47 0 0011.59.86c2.13-.13 2.73-2 2.53-3.88a52.11 52.11 0 0014.37-3.24v.69a2 2 0 002.86 1.76c6-3 10.23-7.35 10.53-13v-13.45c5 1.25 8-2.34 8.12-6.94 1.24-11.45.84-57.39.84-58.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.54 328c-.31-4.9-1.77-9.83-4.15-11.86a6.41 6.41 0 00-1.29-.82L293.76 322c1.5 2.29 4.73 6.15 6.13 10.52a31.33 31.33 0 011.34 9.65v81.93a52.11 52.11 0 0014.37-3.24v-91c0-.61-.02-1.25-.06-1.86z",
    fill: "#07192b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M330.4 409.94c.82-2.18.42-8.6.53-11v-3.81l.22-52.93a1.92 1.92 0 00-1.9-1.92c0 6.88-.25 60.95-.27 66.25v2a3.28 3.28 0 001.39 1.38zM283.91 363.81c-.7-3.44-1.35-6.56-.49-9.34a2.14 2.14 0 00-1-2.51c-3 5.22.09 11.15.1 16.8l1.74-2.71c-.09-.75-.2-1.5-.35-2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M291.8 295.38a4.48 4.48 0 012.54-3.35 12.6 12.6 0 0110.74.23 3.87 3.87 0 012.26 3.18c0 7.33-.06 5.35-.09 12.68v4c4.79 2.41 5.17 10 .43 12.74-3.42 2-8.44.59-12.62-1.32-1.31-.6-2.53-1.26-3.6-1.88-3.6-2.09-4.29-4.41-2.08-6.57a8.42 8.42 0 002.29-4.05 1.35 1.35 0 00.05-.44c.02-7.84.05-7.05.08-15.22z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 36,
    transform: "translate(288 290)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M302.94 332.68a3.43 3.43 0 013.31 4.58l-2.41 6.38a.22.22 0 00.07.26c9.73 9 6.15 16.12-4 23.09l-17.83 39a9.65 9.65 0 01-8.36 5.58 2.56 2.56 0 01-2.65-1.84.05.05 0 01.06-.07c3.65.45 7.67-.88 9.22-4.46l16.95-37.07 1.1-2.42c3.49-2.39 8.41-6.22 9.23-10.3s-3.08-8.28-5.05-10.08a2.16 2.16 0 01-.57-2.35l2.79-7.35c.46-1.21-.25-.7-1.56-1a2.18 2.18 0 00-2.26.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M295.63 365.74a2.15 2.15 0 002.55.12c2.71-1.79 8.71-6.19 9.49-10.47s-3.08-8.28-5.05-10.08a2.16 2.16 0 01-.57-2.35l2.79-7.35a2.16 2.16 0 00-3.81-2c-2.55 3.76-9.09 13.9-8.67 18.35.5 5.25-4.08 7.79 3.27 13.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-73",
    d: "M266.7 408c1.15 1.4 4.51 1.88 7.52 1.56a7.7 7.7 0 006.17-4.42l18-39.29a.26.26 0 00-.09-.32c-5.69-4-6.14-8.87-6-11a.26.26 0 00-.48-.16l-18.17 28.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M300.77 272.08a17.34 17.34 0 00-17.41 17.27V300c.82 23 33.68 23.13 34.68.14v-10.65a17.34 17.34 0 00-17.27-17.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.12 300.13c-.07-.22-.29-.1-.24.13-.2 2.9-1.36 5.33-4.9 4.39-4.39-1.09-8.49 1.37-12.1 2.72-5.75 2.35-10.83-.33-12.21-6.57-.65-2.41-1.12-4.15-5.33-4.4a.14.14 0 00-.13.12V300a17.46 17.46 0 1034.92.13z",
    fill: "#726e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.72 245.05a4.68 4.68 0 01-5.35-5v-1.21a5.35 5.35 0 1110.7 0V240a4.68 4.68 0 01-5.35 5zm-1.78-16.53l-2.27-24.7v-16.28h8.1v16.28l-2.27 24.7z",
    fill: "#0062ff"
  }))));
}; // The types and DocGen commentary for the component props,
// in alphabetical order (for consistency).
// See https://www.npmjs.com/package/prop-types#usage.

HTTPErrorSvgOther.propTypes = {
  className: string
};